<template>
    <div>
        <!-- Filter Start -->
        <div class="innerBox filter">
            <div class="d-flex flex-row justify-content-between">
                <div><h2 class="page-title">NOS</h2></div>
                <div class="d-flex flex-row justify-content-end">
                    <div class="mr-3">
                        <Multiselect
                            :options="options.regions"
                            placeholder="All Region"
                            v-model="filter.region"
                            class="tms-multiselect"
                        />
                    </div>
                    <div class="mr-3">
                        <Multiselect
                            :options="options.ekspedisi.map((x) => x.id)"
                            :custom-label="
                                (opt) =>
                                    options.ekspedisi.find((x) => x.id == opt)
                                        .kode
                            "
                            placeholder="All Ekspedisi"
                            v-model="filter.ekspedisi"
                            class="tms-multiselect"
                        />
                    </div>
                    <div class="mr-3">
                        <router-link
                            to="/dashboard/nos/create-nos"
                            style="color: white; text-decoration: none"
                        >
                            <button
                                class="btn"
                                type="button"
                                style="
                                    background-color: #f36f21;
                                    color: white;
                                    padding: 0 50px;
                                    height: 100%;
                                    width: 100%;
                                    font-weight: bold;
                                "
                            >
                                Create NOS
                            </button>
                        </router-link>
                    </div>
                    <!-- <a href="" class="btn">
                        <img src="@/assets/img/notification.svg" alt="">
                    </a> -->
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Chart Start -->
        <div class="row">
            <div class="col-lg-12 col-md-6">
                <div class="innerBox mt-4">
                    <!-- <input
						class="form-control filterInput col-lg-2"
						type="search"
						placeholder="Search by Nopol"
						aria-label="Search"
						v-model="filter.nopol"
						@input="vue_universal_table.update++"
					/> -->
                    <vue-universal-table
                        class="mt-3"
                        api_url="/api/nos-ekspedisi/list"
                        :indexing="true"
                        :fields="vue_universal_table.fields"
                        :filter="filter"
                        :update="vue_universal_table.update"
                        :buttons="vue_universal_table.buttons"
                        :process_data="vue_universal_table.process_data"
                        :table_striped="false"
                        :pagination="true"
                        sort_order="ASC"
                        sort_by="id"
                        @onDelete="deleteNos"
                        @onEdit="editNos"
                    ></vue-universal-table>
                </div>
            </div>
        </div>
        <!-- Chart End -->
    </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
    metaInfo: {
        title: "NOS",
    },
    data() {
        let startDate = moment().startOf("month").format("YYYY-MM-DD");
        let currentDate = moment().format("YYYY-MM-DD");
        let user = this.$store.getters.currentUser;

        let buttons = null;
        let fields = null;

        buttons = [
            {
                title: "Edit",
                class: "far fa-pencil btn-secondary rounded-button float-right",
            },
            {
                title: "Delete",
                variable: "id",
                class: "fas fa-trash btn-secondary rounded-button",
            },
        ];
        fields = [
            { title: "Ekspedisi", variable: "ekspedisi_code" },
            { title: "Kriteria NOS", variable: "nos_name" },
            { title: "Tanggal Update", variable: "updated_at" },
        ];

        return {
            user,
            apiData: [],
            filter: {
                nopol: "",
                start: startDate,
                end: currentDate,
                ekspedisi: null,
                region: null,
            },
            options: {
                regions: this.$store.getters.getRegion,
                ekspedisi: this.$store.getters.getEkspedisi,
            },
            rangePickr: {
                mode: "range",
                dateFormat: "Y-m-d",
                altInput: true,
                altFormat: "d-m-Y",
                altInputClass: "form-control input grey-flatpickr",
            },
            selected: {
                dateButtonsIndex: 2,
                date: `${startDate} to ${currentDate}`,
            },
            tableWidth: "100%",
            tableHeight: "100%",
            vue_universal_table: {
                fields: fields,
                buttons: buttons,
                filter: {
                    start: startDate,
                    end: currentDate,
                    search: "",
                },
                update: 0,
                process_data: `
					for(var i in data) {
						data[i].updated_at = data[i].updated_at ?? '-'
					}
				`,
            },
        };
    },
    components: { Multiselect },
    watch: {
        "selected.date"() {
            let split = this.selected.date.split(" to ");
            this.filter.start = split[0];
            this.filter.end = split.length > 1 ? split[1] : split[0];
            this.vue_universal_table.update++;
            this.updateDebounceData();
        },
        filter: {
            deep: true,
            handler() {
                if (this.filter.region === 'All' || this.filter.ekspedisi === 999) {
                    this.filter = {...this.filter, region: null, ekspedisi: null};
                }
                this.vue_universal_table.update++;
            },
        },
    },
    methods: {
        onClick(truck) {
            this.$store.state.truckData = truck;
            this.$router.push({ path: "/dashboard/truck-list/detail" });
        },
        editNos(nos) {
            this.$store.state.nosData = nos;
            this.$router.push({ path: "/dashboard/nos/edit-nos" });
        },
        deleteNos(idToDelete) {
            // Use SweetAlert2 to display a confirmation dialog
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "No, cancel",
            }).then((result) => {
                if (result.isConfirmed) {
                    // If the user confirms the delete, proceed with the DELETE request

                    // Define the URL of the DELETE request
                    const url = "/api/nos-ekspedisi/delete-nos";

                    // Define the request body
                    const requestBody = {
                        id: idToDelete,
                    };

                    // Make the DELETE request
                    axios
                        .delete(url, { data: requestBody }) // Pass the request body in the "data" option
                        .then(() => {
                            // Handle the response, e.g., show a success message
                            Swal.fire(
                                "Deleted!",
                                "NOS ekspedisi berhasil dihapus.",
                                "success"
                            );
                            this.vue_universal_table.update++;
                        })
                        .catch(() => {
                            // Handle errors, e.g., show an error message
                            Swal.fire(
                                "Error!",
                                "An error occurred while deleting the record.",
                                "error"
                            );
                        });
                }
            });
        },
        // editNos(editData) {
        // 	let data = JSON.parse(editData);
        // 	// Navigate to the EditMuatPage.vue with the id of the record to edit
        // 	this.$router.push({
        // 		name: "UMuat", //use name for router push
        // 		params: { data }
        // 	});
        // 	// this.$router.push({ name: "UMuat", params: { id: idToEdit } });
        // },
    },
};
</script>

<style>
.rounded-button {
    /* For Fully Rounded Button */
    border-radius: 100000px;

    /* Button to be square */
    width: 38px;
    height: 38px;

    /* Align the button to the middle */
    display: flex;
    align-items: center; /* Vertically Centered */
    justify-content: center; /* Horizontally Centered */

    /* Icon color */
    color: #0c0f1e;

    /* Background color */
    background: #dcdffe;

    /* Add Shadow to the button */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

    /* Remove the border of the button */
    border: 0;
}
</style>

<style scoped>
.align-middle {
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 27px;
    font-weight: bold;
    margin: 0;
}

.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.chart {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
    align-items: center;
}

.elegant--sub-title {
    font-size: 18px;
    font-weight: 500;
    color: #9f9f9f;
}

.stats--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.table td,
.table th {
    text-align: center;
}

.news-image-1 img {
    max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
    text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
    text-align: left; /* To position the news-content on the bottom right */
}

.tms-button-circular {
    width: 40px; /* Set the width and height to the same value for a perfect circle */
    height: 40px;
    border-radius: 50%; /* Makes the button circular */
    background-color: #d8e4ff; /* Sets the background color */
    padding: 10px 20px; /* Adjust padding to fit your content */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    outline: none;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* Adjust shadow values as needed */
}
</style>
